/*
 * Shows an indivual reward with a button to apply it to the order
 */
import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { Order } = Mobi2Go;
const base_class = 'm2g-customer-rewards-modal-reward';

export default forwardRefWithTranslation('customer.rewards')(
    class Reward extends React.Component {
        static propTypes = {
            id: PropTypes.number,
            title: PropTypes.string,
            description: PropTypes.string,
            starts_at: PropTypes.string,
            ends_at: PropTypes.string,
            is_applied_to_order: PropTypes.bool,
            t: PropTypes.func.isRequired,
        };

        getButtonElement = () => {
            const { t } = this.props;
            if (this.props.is_applied_to_order) {
                return (
                    <button
                        onClick={this.props.onUseClick}
                        className={`${base_class}-use-button m2g-button m2g-button--primary m2g-button--disabled`}
                    >
                        {t('applied')}
                    </button>
                );
            }

            return (
                <button
                    onClick={this.props.onUseClick}
                    className={`${base_class}-use-button m2g-button m2g-button--primary`}
                >
                    {t('redeem')}
                </button>
            );
        };

        getRewardDate = () => {
            const { t } = this.props;
            const location = Order.getLocation();
            const current_time = location
                ? location.current_time.clone()
                : moment();
            const starts_at = moment(this.props.starts_at);
            const ends_at = moment(this.props.ends_at);
            const is_valid =
                current_time.isSame(starts_at) ||
                current_time.isAfter(starts_at);

            let display_date = 'valid for x days';

            const relevant_date = is_valid ? ends_at : starts_at;

            const diff_years = relevant_date.diff(current_time, 'years');
            const is_same_year = relevant_date.isSame(current_time, 'year');
            const diff_days = relevant_date.diff(current_time, 'days');
            if (diff_years > 5) {
                return null;
            }
            if (!is_same_year) {
                display_date = t(
                    `display_date_years${is_valid ? '_valid' : ''}`,
                    {
                        date: relevant_date,
                    }
                );
            } else if (diff_days > 7) {
                display_date = t(
                    `display_date_current_year${is_valid ? '_valid' : ''}`,
                    {
                        date: relevant_date,
                    }
                );
            } else if (diff_days > 0) {
                display_date = t(
                    `display_date_current_week${is_valid ? '_valid' : ''}`,
                    {
                        count: diff_days,
                    }
                );
            } else {
                const diff_hours = relevant_date.diff(current_time, 'hours');
                display_date = t(
                    `display_date_current_day${is_valid ? '_valid' : ''}`,
                    {
                        count: diff_hours,
                    }
                );
            }
            return (
                <div
                    className={`${base_class}-date m2g-text--small m2g-text--offset`}
                >
                    {display_date}
                </div>
            );
        };

        render = () => {
            return (
                <div className={`${base_class}`}>
                    <div className={`${base_class}-title`}>
                        {this.props.title}
                    </div>
                    <div
                        className={`${base_class}-description m2g-text--small m2g-text--offset`}
                    >
                        {this.props.description}
                    </div>
                    {this.getButtonElement()}
                    {this.getRewardDate()}
                </div>
            );
        };
    }
);
